import React from "react";
import { Box, Grid, Typography, TextField, Button, Paper } from "@mui/material";
import PublicLayout from "../../layouts/PublicLayout";
import { Container } from "@mui/material";

export default function BookDemo() {
  return (
    <PublicLayout>
      <Container maxWidth="lg">
        <Box sx={{ minHeight: "100vh", pt: 4 }}>
          {/* Hero Section */}
          <Box
            sx={{
              maxWidth: "1200px",
              mx: "auto",
              textAlign: "center",
              py: 4,
              px: 2,
            }}
          >
            <Typography variant="h3" fontWeight={700}>
              Book a <span style={{ color: "#f6521a" }}>Free Demo</span>
            </Typography>

            <Typography
              variant="subtitle1"
              sx={{
                mt: 2,
                color: "text.secondary",
                maxWidth: "700px",
                mx: "auto",
                fontSize: "18px",
              }}
            >
              See how Truemenu POS (TPOS) can streamline your billing,
              inventory, KOT, online orders, reporting & entire outlet
              operations — all in one powerful system.
            </Typography>
          </Box>

          {/* Main Section */}
          <Grid
            container
            justifyContent="center"
            spacing={4}
            sx={{ maxWidth: "1200px", mx: "auto", px: 2 }}
          >
            {/* Left Info Section */}
            <Grid item size={{ xs: 12, md: 6 }}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  borderRadius: 3,
                  bgcolor: "#ffffff",
                }}
              >
                <Typography variant="h5" fontWeight={600} gutterBottom>
                  What you’ll learn in the demo
                </Typography>

                <Box sx={{ mt: 2, color: "text.secondary", fontSize: "16px" }}>
                  <ul style={{ lineHeight: "28px", paddingLeft: "20px" }}>
                    <li>How TPOS simplifies your daily billing operations</li>
                    <li>Managing menu, categories & modifiers seamlessly</li>
                    <li>Table management, KOT control & kitchen workflows</li>
                    <li>Real-time inventory & low-stock alerts</li>
                    <li>
                      Access 25+ reports: sales, tax, staff, outlet insights
                    </li>
                    <li>Full cloud sync + offline fallback</li>
                  </ul>
                </Box>

                <Typography
                  variant="subtitle2"
                  sx={{ mt: 3, fontSize: "14px", color: "#888" }}
                >
                  100% free • No credit card required • Takes 20–25 minutes
                </Typography>
              </Paper>
            </Grid>

            {/* Right Form Section */}
            <Grid item size={{ xs: 12, md: 7 }}>
              <Paper
                elevation={2}
                sx={{
                  p: 4,
                  borderRadius: 3,
                  bgcolor: "#fff",
                }}
              >
                <Typography variant="h5" fontWeight={600} gutterBottom>
                  Fill your details
                </Typography>

                <Grid container spacing={3} sx={{ mt: 1 }}>
                  <Grid item size={{ xs: 12, md: 6 }}>
                    <TextField
                      fullWidth
                      label="Full Name"
                      variant="outlined"
                      autoComplete="full-name"
                    />
                  </Grid>

                  <Grid item size={{ xs: 12, md: 6 }}>
                    <TextField
                      fullWidth
                      label="Mobile Number"
                      variant="outlined"
                      autoComplete="mobile-number"
                    />
                  </Grid>

                  <Grid item size={{ xs: 12, md: 6 }}>
                    <TextField
                      fullWidth
                      label="Email Address"
                      variant="outlined"
                      autoComplete="email-address"
                    />
                  </Grid>

                  <Grid item size={{ xs: 12, md: 6 }}>
                    <TextField
                      fullWidth
                      label="Business Name"
                      variant="outlined"
                      autoComplete="demo-business-name"
                    />
                  </Grid>

                  <Grid item size={{ xs: 12, md: 6 }}>
                    <TextField
                      fullWidth
                      label="Outlet Type"
                      placeholder="Restaurant, Cafe, Retail, Bakery, Cloud Kitchen..."
                      autoComplete="outlet-type"
                    />
                  </Grid>

                  <Grid item size={{ xs: 12, md: 6 }}>
                    <TextField
                      fullWidth
                      multiline
                      rows={3}
                      label="Tell us about your requirement"
                      autoComplete="requirement"
                    />
                  </Grid>

                  <Grid item size={{ xs: 12, md: 5 }}>
                    <Button
                      variant="contained"
                      fullWidth
                      size="large"
                      sx={{
                        py: 1.5,
                        fontSize: "16px",
                        backgroundColor: "#f6521a",
                        ":hover": { backgroundColor: "#d94514" },
                      }}
                    >
                      Schedule My Demo
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>

          {/* Trust Section */}
          <Box
            sx={{
              textAlign: "center",
              mt: 10,
              mb: 4,
              color: "text.secondary",
              fontSize: "16px",
            }}
          >
            Trusted by cafés, restaurants, cloud kitchens & retail stores across
            India.
          </Box>
        </Box>
      </Container>
    </PublicLayout>
  );
}
